const getVisitor = (data) => ({
  id: data.systemUserId,
  status: data.status,
  hasClaimCodePermissions: data.hasClaimCodePermissions,
  hasGiveBarEnabled: data.hasGiveBarEnabled,
  hasGiveWidgetEnabled: data.hasGiveWidgetEnabled,
  hasWelcomeMessageEnabled: data.hasWelcomeMessageEnabled
});
  
const getAccount = (data) => ({
  id: data.theme.stp,
  primaryHexColor: data.theme.primaryHexColor
});
  
const construct = (data) => {
  const dataLayer = {
    visitor: getVisitor(data)
  };
  
  if (data.theme) {
    dataLayer.account = getAccount(data);
  }
  return dataLayer;
};
  
const initPendo = (pendo, data) => pendo && data && pendo.initialize(construct(data));
  
export default initPendo;
